<template>
  <el-col :span="24">
    <template v-for="form in forms">
      <el-form-item
        v-if="
          form.type == 'text' ||
            form.type == 'password' ||
            form.type == 'number'
        "
        size="small"
        :key="form.label"
        :prop="form.id"
        :label="form.label"
        :rules="form.rules"
      >
        <el-input
          v-model="Category[form.id]"
          :type="form.type"
          :placeholder="`Please input ${form.label}`"
        ></el-input>
      </el-form-item>
    </template>

    <el-form-item size="small" :prop="forms[2].id" :label="forms[2].label" :rules="forms[2].rules">
      <el-input
        type="textarea"
        :rows="2"
        :placeholder="`Please input ${forms[2].label}`"
        v-model="Category[forms[2].id]"
      ></el-input>
    </el-form-item>
    <el-form-item size="small" :prop="forms[3].id" :label="forms[3].label" :rules="forms[3].rules">
      <el-col :span="12">
        <el-select
          v-model="Category[forms[3].id]"
          :placeholder="`Please select ${forms[3].label}`"
          style="width: 100%"
          filterable
          remote
          :remote-method="onSearch"
          :loading="categories.isLoading"
        >
          <el-option
            v-for="item in forms[3].data"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
          <el-row type="flex" justify="center">
            <el-button
              :loading="categories.isLoading"
              size="mini"
              round
              @click="loadMoreCategory"
            >Load More</el-button>
          </el-row>
        </el-select>
      </el-col>
    </el-form-item>
    <el-form-item size="small" :prop="forms[4].id" :label="forms[4].label" :rules="forms[4].rules">
      <el-select v-model="Category[forms[4].id]" :placeholder="`Please select ${forms[4].label}`">
        <el-option
          v-for="item in forms[4].data"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item size="small" prop="picture" label="Picture">
      <el-row>
        <el-image style="width: 100%; height: 260px" :src="Category.picture" fit="contain"></el-image>
        <input
          style="display: none"
          type="file"
          placeholder="Please Input Payment Note"
          ref="fileInputPicture"
          accept="image/*"
          @change="e => onFilePicked(e, 'picture')"
        />

        <el-row type="flex" justify="center" class="mt-2">
          <el-col :span="12">
            <el-button
              type="primary"
              size="small"
              @click="onPickFile('picture')"
              style="width: 100%"
            >Upload</el-button>
          </el-col>
        </el-row>
      </el-row>
    </el-form-item>
    <el-form-item size="small" prop="thumbnail" label="Thumbnail">
      <el-row>
        <el-image style="width: 100%; height: 260px" :src="Category.thumbnail" fit="contain"></el-image>
        <input
          style="display: none"
          type="file"
          placeholder="Please Input Payment Note"
          ref="fileInputThumbnail"
          accept="image/*"
          @change="e => onFilePicked(e, 'thumbnail')"
        />

        <el-row type="flex" justify="center" class="mt-2">
          <el-col :span="12">
            <el-button
              type="primary"
              size="small"
              @click="onPickFile('thumbnail')"
              style="width: 100%"
            >Upload</el-button>
          </el-col>
        </el-row>
      </el-row>
    </el-form-item>
    <el-form-item size="small" :prop="forms[6].id" :label="forms[6].label" :rules="forms[6].rules">
      <el-switch v-model="Category[forms[6].id]"></el-switch>
    </el-form-item>
  </el-col>
</template>

<script>
import S3Client from "../../common/S3/S3Client";
import configS3 from "../../common/S3/configS3";
import { mapActions, mapState } from "vuex";
export default {
  props: ["Category"],
  data() {
    return {
      limitCategory: 25,
    };
  },
  computed: {
    ...mapState({
      categories: state => state.category.categories
    }),
    forms() {
      return [
        {
          type: "text",
          id: "kategoriCode",
          label: "Category Code",
          rules: [
            {
              required: true,
              message: "Category Code is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "number",
          id: "kategoriLevel",
          label: "Category Level",
          rules: [
            {
              required: true,
              message: "Category Level is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "textarea",
          id: "description",
          label: "Description",
          rules: [
            {
              required: true,
              message: "Description is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "select",
          id: "parentId",
          label: "Parent ID",
          rules: [],
          data: this.categories.data
            ? this.categories.data.map(item => {
              item.name = `${item.kategoriCode} - ${item.categoryName}`;
              item.value = item.kategoriCode;
              return item;
            })
            : []
        },
        {
          type: "select",
          id: "hasChild",
          label: "Has Child",
          rules: [],
          data: [
            {
              name: "true",
              value: true
            },
            {
              name: "false",
              value: false
            }
          ]
        },
        {
          type: "null",
          id: "internalCode",
          label: "Internal Code",
          rules: []
        },
        {
          type: "switch",
          id: "isActive",
          label: "Status",
          rules: [],
          data: [
            {
              name: "true",
              value: true
            },
            {
              name: "false",
              value: false
            }
          ]
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getCategory: "category/GetCategorys",
    }),
    onPickFile(type) {
      if (type === "picture") {
        this.$refs.fileInputPicture.click();
      } else if (type === "thumbnail") {
        this.$refs.fileInputThumbnail.click();
      }
    },
    onSearch(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getCategory(option);
    },
    loadMoreCategory() {
      this.limitCategory += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCategory,
        }
      };
      this.getCategory(option);
    },
    async onFilePicked(event, type) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      const config = configS3(
        "fastmart-image",
        `${process.env.NODE_ENV}/category`
      );
      const file = await S3Client.uploadFile(files[0], config);
      fileReader.addEventListener("load", () => {
        if (type === "picture") {
          this.Category.picture = file.location;
        } else if (type === "thumbnail") {
          this.Category.thumbnail = file.location;
        }
      });
      fileReader.readAsDataURL(files[0]);
    }
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getCategory(option);
  }
};
</script>

<style></style>
